import React, { useEffect, useState, useLayoutEffect, useImperativeHandle, useContext } from "react";
import CompanyChartMF from './CompanyChartMF/CompanyChartMF';
import { useParams } from "react-router-dom";
import { Container, Col, Row } from "react-bootstrap";
import MutualFundHoldings from "./MutualFundHoldings/MutualFundHoldings";
import MFPeerComparison from "./MFPeerComparison/MFPeerComparison";
import MFDividend from "./MFDividend/MFDividend";
import MFAssetsAllocation from "./MFAssetsAllocation/MFAssetsAllocation";
import SectorAllocationMF from './SectorAllocationMF/SectorAllocationMF';
import URLstateContext from "../../provider/CommonContext";
import CompanyLogo from "../../Images/comlogo.png";
import SchemedetailsMF from "./SchemedetailsMF/SchemedetailsMF";
import SchemeFAQ from "./SchemeFAQ/SchemeFAQ";
import MfSchemeCard from "./MfSchemeCard/MfSchemeCard";
import { Link, Element, Events, animateScroll as scroll, scroller, } from "react-scroll";
// import './../SchemeSnapshot.css'
import './SchemeSnapshot.css'
import MfPerformance from './MfPerformance/MfPerformance'
import MfRatios from "./MfRatio/MfRatios";
// import MfCardNFO from "../Market/MfLanding/MfCardNFO"
function SchemeSnapshot(props) {

  const { MFCode } = useParams();
  const [data, setData] = useState([]);
  const [MFcode, setMFcode] = useState([]);
  const [dataName, setDataName] = useState([]);
  const [dataAll, setDataAll] = useState([]);
  const [chartdata, setchartData] = useState([]);
  // let getMFCode = props.MFcode;
  const { BaseURL } = useContext(URLstateContext);
  let getData, getDataName;

  useEffect(() => {

    const getUrlName = BaseURL + "companysearchMutualFund";
    fetch(`${getUrlName}/${MFCode}`)
      .then((response) => response.json())
      .then((dataN) => {
        getDataName = dataN.data;
        setDataName(getDataName);
        setDataAll(getDataName);
        setMFcode(dataN.data[0]["MF_SCHCODE"]);
      })
      .catch((error) => {
        //console.log("not found the api");
      });
  }, []);
  useEffect(() => {
    if (MFcode != '') {
      const getUrl = BaseURL + "GetQuoteDetailsMF";
      fetch(`${getUrl}/${MFcode}`)
        .then((response) => response.json())
        .then((data) => {
          getData = data.data;
          setData(getData);
          //console.log("aaaaaaa", getData);
        })
        .catch((error) => {
          //console.log("not found the api");
        });
    }
  }, [MFcode]);


  useEffect(() => {
    window.addEventListener("scroll", handleScrollMF);
    return () => {
      window.removeEventListener("scroll", handleScrollMF);
    };
  });

  const handleScrollMF = (e) => {
    const fixsc = document.querySelector(".scheme-fundamental-sectionKey");
    const scrollTop = window.scrollY;
    scrollTop >= 150
      ? fixsc.classList.add("col-sticky")
      : fixsc.classList.remove("col-sticky");

    const bottom =
      e.target.scrollingElement.scrollHeight -
      e.target.scrollingElement.scrollTop < 2000

    // console.log(e);
    //console.log(bottom);
    if (bottom) {
      fixsc.classList.remove("col-sticky");
    }
  }
  useEffect(() => {

    window.addEventListener("scroll", snapshottabscroll);
    return () => {
      window.removeEventListener("scroll", snapshottabscroll);
    };

  });
  const snapshottabscroll = (e) => {
    const fixsc = document.querySelector(".company-snap-tabs");
    const scrollTop = window.scrollY;
    scrollTop >= 150
      ? fixsc.classList.add("tab-sticky")
      : fixsc.classList.remove("tab-sticky");

  }
  return (
    <>
      <section className="market-sc scheme">
        <Container className="company-snap-tabs">
          <Row>
            <nav className="company-snap">
              <ul className="ulsnap">
                <li>
                  <Link to="section-1" spy={true} smooth={true}>
                    NAV Chart
                  </Link>
                </li>
                <li>
                  <Link to="section-2" spy={true} smooth={true}>
                    Holdings
                  </Link>
                </li>
                <li>
                  <Link to="section-3" spy={true} smooth={true}>
                    Peer Comparison
                  </Link>
                </li>
                <li>
                  <Link to="section-4" spy={true} smooth={true}>
                    Dividend
                  </Link>
                </li>
                <li>
                  <Link to="section-5" spy={true} smooth={true}>
                    Assets Allocation
                  </Link>
                </li>
                <li>
                  <Link to="section-6" spy={true} smooth={true}>
                    Sector Allocation
                  </Link>
                </li>
                <li>
                  <Link to="section-7" spy={true} smooth={true}>
                    Summary
                  </Link>
                </li>
                <li>
                  <Link to="section-9" spy={true} smooth={true}>
                    Performance
                  </Link>
                </li>
                <li>
                  <Link to="section-10" spy={true} smooth={true}>
                    Ratios
                  </Link>
                </li>
                <li>
                  <Link to="section-8" spy={true} smooth={true}>
                    Faq
                  </Link>
                </li>
              </ul>
            </nav>
          </Row>
        </Container>
        {(dataAll != null) ?
          <Container>
            <Row>
              <Col md={8}>
                <main className="react-scroll-page">
                  <section className="company-chart-section">

                    <div className="company-details-block">
                      <div className="company-details-block">
                        {data != null && data.map((eachData) => (
                          <>
                            <div className="company-name">
                              <h2>
                                <img src={CompanyLogo} alt="CompanyLogo-img" />
                                &nbsp;
                                <span>{eachData.SchemeName}</span>
                              </h2>
                            </div>
                          </>
                        ))}
                      </div>
                    </div>
                  </section>

                  <Element name="section-1" className="page-section page-section-1" id="chartComponent">
                    <CompanyChartMF MFcode={MFcode} name="section-1" className="page-section page-section-1" />
                  </Element>
                  <Element name="section-2" className="page-section page-section-0" id="chartComponentFandO">
                    <MutualFundHoldings MFcode={MFcode} name="section-0" className="page-section page-section-0" />
                  </Element>
                  <Element name="section-3" className="page-section page-section-2">
                    <MFPeerComparison MFcode={MFcode} />
                  </Element>
                  <Element name="section-4" className="page-section page-section-3">
                    <MFDividend MFcode={MFcode} />
                  </Element>
                  <Element name="section-5" className="page-section page-section-4">
                    <MFAssetsAllocation MFcode={MFcode} />
                  </Element>
                  <Element name="section-6" className="page-section page-section-5">
                    <SectorAllocationMF MFcode={MFcode} />
                  </Element>
                  <Element name="section-7" className="page-section page-section-6">
                    <SchemedetailsMF MFcode={MFcode} />
                  </Element>
                  <Element name="section-9" className="page-section page-section-7">
                    <MfPerformance MFcode={MFcode} />
                  </Element>
                  <Element name="section-10" className="page-section page-section-7">
                    <MfRatios MFcode={MFcode} />
                  </Element>
                  <Element name="section-8" className="page-section page-section-7">
                    <SchemeFAQ />
                  </Element>
                </main>
              </Col>
              <Col md={4}>
                <MfSchemeCard onScroll={handleScrollMF} MFcode={MFcode} />

              </Col>
            </Row>
          </Container> : <div className="compInfoMain">
            <div className="textErrorDiv">Uh Oh! 404</div>
            <h1>Page Not Found</h1>
            <a href="/">Go to Home Page</a>
          </div>}
      </section>


    </>
  )
}
export default SchemeSnapshot;



